import React from 'react'

export function ErrorPage() {
  return <div className="text-2xl">Not FOund</div>
}
